// removed by extract-text-webpack-plugin
module.exports = {"popUp":"_3NTr2oSul8OCoEIGXs0ddH","popup-newsletter":"_2RSDE6s7j-0XfUyzHIC2sa","activatePopUp":"fZAxUVV2dt20fgPSnCbgI","subsrcibe":"_142p2TbrbX9DQwEBOj9hE-","popUpContainer":"_3vC_pC_laJgQYzl2aKGMUd","headline":"_2d051jpmJzyyDDQ0uW2zcj","text":"_3yCbtObjpMhJscqZ3tJC7K","info":"_2k0D2rBtsrmsysrjPZP48G","readmore":"oZqBVXrRRlpg2mlOwiV82","accept":"_1xNqh38MXnDLf5PUDx5NLc","donutSpinner":"_1BK-wQp8h0EM1hpLYbhSAP","donut-spin":"_3xLnsAhiVb8_Kcgf4_d_fN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsletterPopUp/NewsletterPopUp.css
// module id = 282
// module chunks = 8